import { isBefore, sub } from 'date-fns';
import * as yup from 'yup';

// Copied from PersonalDetailsDE.schema.ts — keep in sync if the desktop rule changes.
const dayRegex = /\b(0?[1-9]|[1-2][0-9]|[3][0-1])\b/;
const monthRegex = /^(?:0?[1-9]|1[012])$/;

const isOver18 = (year: string, month: string, day: string) => {
  const date18YearsAgo = sub(new Date(), { years: 18 });
  return isBefore(
    new Date(parseInt(year), parseInt(month) - 1, parseInt(day)),
    date18YearsAgo,
  );
};

export const dateOfBirthSchema = yup.object().shape({
  dobDay: yup
    .string()
    .required('benötigt')
    .matches(dayRegex, 'ungültige Eingabe'),
  dobMonth: yup
    .string()
    .required('benötigt')
    .matches(monthRegex, 'ungültige Eingabe'),
  dobYear: yup
    .string()
    .required('benötigt')
    .min(4, 'benötigt')
    .max(4, 'ungültige Eingabe')
    .test('Is 18 or over', 'Mindestalter 18 Jahre', function (value, ctx) {
      if (!Number(ctx.parent.dobMonth) || !Number(ctx.parent.dobDay))
        return true;
      return isOver18(value as string, ctx.parent.dobMonth, ctx.parent.dobDay);
    }),
});
